import { Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Playground from "./pages/Playground";
import FitnessApp from "./pages/FitnessApp";
import WorkoutPlanLegacyCompatibility from "./pages/WorkoutPlanLegacyCompatibility";

import BinderBuilders from "./pages/BinderBuilders";
import BinderBuildersProduct from "./pages/BinderBuildersProduct";
import BarnRelay from "./pages/BarnRelay";


export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/playground" element={<Playground />} />
      <Route path="/fitness-app" element={<FitnessApp />} />
      <Route path="/workout_plan/*" element={<WorkoutPlanLegacyCompatibility />} />
      <Route path="/binder-builders" element={<BinderBuilders />} />
      <Route path="/binder-builders/:slug" element={<BinderBuildersProduct />} />
      <Route path="/barnrelay" element={<BarnRelay />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function NotFound() {
  return (
    <div style={shell}>
      <h1 style={{ marginTop: 0 }}>Page not found</h1>
      <p style={{ lineHeight: 1.6 }}>
        That link doesn’t exist. Head back home.
      </p>
      <Link to="/" style={linkStyle}>Go home →</Link>
    </div>
  );
}

const shell = {
  maxWidth: 900,
  margin: "0 auto",
  padding: "48px 20px",
  fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
};

const linkStyle = { display: "inline-block", textDecoration: "none", fontWeight: 600 };
